<ng-container *transloco="let t">
  <div>
    <nz-page-header nzBackIcon class="bg-slate-100" [nzGhost]="false">
      <nz-page-header-title class="text-primary">
        {{ t('experiences.editor.pageTitle') }}
      </nz-page-header-title>
    </nz-page-header>
  </div>

  <div *ngIf="pageType !== 'edit'" class="my-8">
    <div class="grid xl:grid-cols-2 sm:grid-cols-2">
      <div>
        <nz-select
          class="w-full"
          nzShowSearch
          nzServerSearch
          [nzPlaceHolder]="t('experiences.editor.searchExperience')"
          [(ngModel)]="searchName"
          [nzShowArrow]="false"
          (nzOnSearch)="search($event)"
          (ngModelChange)="selectedResult(searchName)">
          <nz-option
            nzCustomContent
            *ngFor="let option of listOfOption"
            nzLabel="{{ option.placePrediction.entry ? option.placePrediction.text.text + ' [Manual]' : option.placePrediction.text.text }}"
            [nzValue]="option.placePrediction">

            <div class="flex justify-start items-center">
              <div class="mr-2" *ngIf="option.placePrediction.entry !== undefined">
                <lucide-icon class="search-icons flex" name="plus"></lucide-icon>
              </div>
              <div [ngClass]="option.placePrediction.entry ? 'text-primary' : 'text-[#000000d9]'">
                {{ option.placePrediction.text.text }}
              </div>
            </div>
          </nz-option>
        </nz-select>

        <div class="mt-5 flex justify-end">
          <button
            nz-button
            class="mr-2"
            nzType="primary"
            [disabled]="!isDetailsExist"
            (click)="addUpdateExperience(pageType === 'new' ? 'ADD' : 'EDIT')">
            {{ t('experiences.editor.addBtn') }}
          </button>
          <button nz-button nzType="default" (click)="reset()">
            {{ t('experiences.editor.resetBtn') }}
          </button>
        </div>
      </div>
    </div>

    <div class="mt-5 grid grid-cols-12">
      <div class="col-span-6">
        <nz-alert
          *ngIf="actionMessage.display && actionMessage.isAdd"
          [nzType]="actionMessage.type"
          [nzMessage]="actionMessage.message"
          nzShowIcon
          nzCloseable></nz-alert>
      </div>
    </div>
  </div>

  <nz-divider nzType="horizontal"></nz-divider>

  <div class="my-8" *ngIf="pageType === 'edit'">
    <div class="grid lg:grid-cols-2 gap-6">
      <div>
        <div class="flex justify-between items-center">
          <h6>{{ experienceName }}</h6>
        </div>

        <div class="mt-4">
          <div class="flex flex-wrap gap-2">
            <div
              *ngFor="let file of fileList"
              class="custom-upload-card"
              [class.is-default]="file.url === userPreferredImage">
              <img
                [src]="file.url || file.thumbUrl"
                class="card-img"
                alt="experience image" />

              <div
                *ngIf="file.url === userPreferredImage"
                class="absolute top-2 right-2 z-20 flex items-center justify-center w-6 h-6 rounded-full bg-violet-600 text-white shadow-md">
                <span nz-icon nzType="check" nzTheme="outline" class="text-xs leading-none"></span>
              </div>

              <div
                class="absolute inset-0 z-10 flex flex-col items-center justify-center bg-black/45 text-white"
                *ngIf="file.status === 'uploading'">
                <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
                <div class="mt-2 text-xs font-medium">
                  Uploading... {{ file.percent ? (file.percent | number:'1.0-0') + '%' : '' }}
                </div>
              </div>

              <div
                class="absolute inset-0 z-10 flex flex-col items-center justify-center bg-red-600/60 text-white"
                *ngIf="file.status === 'error'">
                <span nz-icon nzType="close-circle" nzTheme="fill" class="text-xl"></span>
                <div class="mt-2 text-xs font-medium">Upload failed</div>
              </div>

              <div class="card-overlay" *ngIf="file.status === 'done' && file.url">
                <div class="card-actions">
                  <button nz-button nzType="text" class="card-action-btn" (click)="handlePreview(file)">
                    <span nz-icon nzType="eye" nzTheme="outline"></span>
                  </button>
                  <button nz-button nzType="text" class="card-action-btn" (click)="download(file)">
                    <span nz-icon nzType="download" nzTheme="outline"></span>
                  </button>
                  <button nz-button nzType="text" class="card-action-btn" (click)="onRemove(file)">
                    <span nz-icon nzType="delete" nzTheme="outline"></span>
                  </button>
                </div>
                <button nz-button class="set-default-btn" (click)="setAsDefaultImage(file)">
                  SET AS DEFAULT
                </button>
              </div>
            </div>

            <nz-upload
              [nzMultiple]="true"
              [(nzFileList)]="fileList"
              [nzCustomRequest]="customUploadReq"
              (nzChange)="handleChange($event)"
              nzListType="picture-card"
              nzAccept="image/png,image/jpg,image/jpeg"
              [nzShowUploadList]="false">
              <div>
                <span nz-icon nzType="plus"></span>
                <div style="margin-top: 8px">{{ t('experiences.editor.upload') }}</div>
              </div>
            </nz-upload>
          </div>
        </div>

        <nz-alert
          nzType="info"
          nzShowIcon
          [nzMessage]="t('experiences.editor.uploadInfo')"></nz-alert>

        <div class="mt-6">
          <nz-form-item class="flex">
            <nz-form-label nzFor="url">
              {{ t('experiences.editor.urlLabel') }}
            </nz-form-label>
            <nz-form-control>
              <input
                [(ngModel)]="this.url"
                type="text"
                class="w-full"
                [placeholder]="t('experiences.editor.urlPlaceholder')"
                nz-input>
            </nz-form-control>
          </nz-form-item>
          <div class="flex justify-end">
            <button
              nz-button
              nzType="default"
              (click)="this.updateUrl('edit')">
              {{ t('experiences.editor.updateBtn') }}
            </button>
          </div>
        </div>
      </div>

      <div>
        <div class="flex justify-between items-center">
          <h6>{{ t('experiences.editor.showingResultsFor') }} {{ this.languageType?.name }}</h6>
          <div>
            <nz-select [(ngModel)]="language" [formControl]="languageField">
              <nz-option
                *ngFor="let lang of getSelectedLanguagesObjectArray()"
                [nzValue]="lang?.code"
                [nzLabel]="lang?.name"></nz-option>
            </nz-select>
          </div>
        </div>

        <div class="mt-4">
          <nz-form-item class="flex">
            <nz-form-label nzRequired nzFor="title">
              {{ t('experiences.editor.titleLabel') }}
            </nz-form-label>
            <nz-form-control>
              <input
                [(ngModel)]="this.title"
                (ngModelChange)="onTitleChange($event)"
                type="text"
                class="w-full"
                [placeholder]="t('experiences.editor.titlePlaceholder')"
                nz-input>
            </nz-form-control>
          </nz-form-item>

          <div *ngIf="!isHidden && this.languageType?.name !== 'English'">
            <p class="flex justify-items-center font-bold">
              <app-sparkles-svg></app-sparkles-svg>
              <span class="ai-text-color ml-1 text-base">{{ t('experiences.editor.translateLabel') }}</span>
            </p>
            <p
              class="bg-slate-100 cursor-pointer font-semibold rounded-lg p-2 mt-2 mb-4"
              (click)="onTitleChange(this.translatedTitle); this.isHidden = true">
              {{ this.translatedTitle }}
            </p>
          </div>

          <div class="flex justify-end">
            <button
              nz-button
              nzType="default"
              [disabled]="this.title === ''"
              (click)="updateTitle('edit')">
              {{ t('experiences.editor.updateBtn') }}
            </button>
          </div>
        </div>

        <nz-divider></nz-divider>

        <div class="flex justify-between items-center">
          <h6>{{ t('experiences.editor.descriptions') }}</h6>
          <div class="flex flex-row">
            <button
              class="mr-3 ai-button flex items-center"
              nz-button
              nzType="default"
              (click)="addEditDescription(null, null, SETTINGS.CONTENT_TYPES.GENERATED, {name: this.experienceName, language: this.languageType?.name }, 'experiences')">
              <span nz-icon nzType="plus"></span>
              {{ t('experiences.editor.quickGenerate') }}
            </button>
            <button
              class="text-primary"
              nz-button
              nzType="default"
              (click)="addEditDescription(null, null, SETTINGS.CONTENT_TYPES.TYPED, {}, 'experiences')">
              <span nz-icon nzType="plus"></span>
              {{ t('experiences.editor.addDescriptionBtn') }}
            </button>
          </div>
        </div>

        <div class="my-4">
          <nz-list class="bg-slate-50" nzBordered nzItemLayout="vertical">
            <nz-list-empty *ngIf="contexts?.length === 0 || !contexts"></nz-list-empty>
            <div *ngFor="let context of contexts">
              <nz-list-item class="mb-3">
                <div class="w-full">
                  <div class="mb-2 innerHtml-cls" [innerHTML]="context.body"></div>
                  <div class="flex justify-between">
                    <div>
                      <p class="font-bold" *ngFor="let keyword of context.keyword.split('\n')">
                        {{ t('experiences.editor.keyword') }}: {{ keyword }}
                      </p>
                    </div>
                    <div class="flex flex-row gap-2">
                      <button
                        nz-button
                        nzType="default"
                        (click)="addEditDescription(context.body, context.keyword, SETTINGS.CONTENT_TYPES.TYPED, {}, 'experiences')"
                        class="flex items-center justify-center gap-2">
                        <lucide-icon name="pencil" class="icon-size"></lucide-icon>
                        {{ t('experiences.editBtn') }}
                      </button>
                      <button
                        nz-button
                        nzType="default"
                        nzDanger
                        (click)="deleteDescription(context)"
                        class="flex items-center justify-center gap-2">
                        <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
                      </button>
                    </div>
                  </div>
                  <div
                    *ngIf="context.type === SETTINGS.CONTENT_TYPES.GENERATED"
                    class="flex justify-end mt-7">
                    <p class="flex justify-items-center font-bold">
                      <app-sparkles-svg></app-sparkles-svg>
                      <span class="ai-text-color ml-1 text-base">{{ t('experiences.editor.generatedBy') }}</span>
                    </p>
                  </div>
                </div>
              </nz-list-item>
            </div>
          </nz-list>
        </div>
      </div>
    </div>
  </div>

  <nz-modal
    [nzVisible]="previewVisible"
    [nzContent]="modalContent"
    [nzFooter]="null"
    (nzOnCancel)="previewVisible = false">
    <ng-template #modalContent>
      <img
        [src]="previewImage ? previewImage : placeholderPath"
        [ngStyle]="{ width: '100%' }" />
    </ng-template>
  </nz-modal>
</ng-container>